import { UnavailabilityHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

interface IProps {
  userId?: number;
  workStationId?: string;
}

export const useUnavailability = ({ userId, workStationId }: IProps): UnavailabilityHook => {
  const { unavailabilityStore } = useStore();
  const { unavailability, loading, skipCount, maxResultCount, currentPage, totalCount } =
    unavailabilityStore;

  useEffect(() => {
    return () => unavailabilityStore.resetUnavailability();
  }, [unavailabilityStore]);

  useEffect(() => {
    unavailabilityStore.getAll({ userId, workStationId, skipCount, maxResultCount });
  }, [unavailabilityStore, userId, workStationId, skipCount, maxResultCount]);

  return {
    dataSource: Array.from(unavailability.values()),
    totalCount,
    loading,
    skipCount,
    maxResultCount,
    currentPage,
    handlePageChange: unavailabilityStore.handlePageChange,
  };
};
